/**Nhap danh muc chu tau */
import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormLabel,
  OutlinedInput,
  InputBase,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import SelectFilter from "react-select";

/*----------------------Cac control trong project su dung den trong form----------------*/
import {
  filterStyles,
  formStyles,
  loadDataError,
  handleServerError,
  ReactDataGrid_i18n,
  showError,
} from "../components/common";
import SimpleDialog from "../components/SimpleDialog";
import MyNumberEditor from "../components/MyNumberEditor";
import MyDateEditor from "../components/MyDateEditor";
import MyDateTimeEditor from "../components/MyDateTimeEditor";
import MyLatLonEditor from "../components/MyLatLonEditor";
import MySelectFilter from "../components/MySelectFilter";

/*-----------------------Cac thu vien dung chung -------------------------*/
const myLib = require("../lib/MyLib");
const server = require("../lib/server");
const dataStruct = require("../data/DataStruct");
/*-----------------------Cac dinh nghia ----------------------------------*/
const englishUI = true;

/*-----------------------Dinh nghia cac label tieng Anh, tieng Viet su dung trong form*/
const formTitle = englishUI ? "COPY CHECKING RULE" : "SAO CHÉP QUY TẮC KIỂM SOÁT";
const fieldLabels = englishUI
  ? {
    CheckRuleID: "Rule Code:",
    ShipName: "From Ship:",
    ToShip: "To ship:",
    RuleName: "Rule name:",
    NgayHieuLuc: "From date:",
    RuleExpression: "Expression:",
    ActionGuide: "Action guide:",

    Active: "Active",
    CompareValue1: "Value 1:",
    CompareValue2: "Value 2:",
    CompareValue3: "Value 3:",
  }
  : {
    CheckRuleID: "Mã quy tắc:",
    ShipName: "Từ tàu:",
    ToShip: "Sang tàu:",
    RuleName: "Tên quy tắc:",
    NgayHieuLuc: "Áp dụng từ:",
    RuleExpression: "Biểu thức:",
    ActionGuide: "Hướng xử lý:",
    Active: "Hoạt động",
    CompareValue1: "Limit value:",
  };
const buttonLabels = englishUI
  ? {
    btnRun: "Run rule",
    btnSave: "Save",
    btnClose: "Close",
  }
  : {
    btnSave: "Lưu",
    btnClose: "Thoát",
  };

function validate_Data(data) {
  var ret = myLib.validateEmpty(data, [
    "ShipID",
    "ToShipID",
    "NgayHieuLuc",
  ]);
  if (Object.keys(ret).length == 0) {
    //ko co loi thi kiem tra cac dieu kien khac
  }

  ret.error = Object.keys(ret).length > 0;
  ret.GUID = new Date(); //danh dau version

  return ret;
}
////////////////////////--------------/////////////////////////////////////////
export default class VoyageEditDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validateStatus: { error: false }, //trang thai validate
      DanhMuc: {},
      after: {
        CheckRuleID: "",
        ShipName: props.ShipData.ShipName,
        ShipID: props.ShipData.ShipID, //lay thong tin tu ship data
        ToShipName: "",
        ToShipID: 0,
        Active: true,
        NgayHieuLuc: null,
        MinValue: 0,
        MaxValue: 0,
        NgayHieuLuc: myLib.getNowDate(),
        ...(props.edittingRecord ? props.edittingRecord : {}),
      },
    };
  }

  componentDidMount() {
    this.loadDanhMuc();
  }
  //load du lieu khi form load
  loadDanhMuc() { }
  //call khi user thay doi trang
  static getDerivedStateFromProps(nextProps, prevState) {
    return { open: nextProps.open };
  }
  saveField = (fieldName, value) => {
    var old_changed = this.state.dataChanged;
    var s = { after: { ...this.state.after } }; //new value
    s.after[fieldName] = value;
    s.dataChanged = true;
    this.setState(s);
  };
  saveData = (obj) => {
    var old_changed = this.state.dataChanged;
    var s = {};
    s.dataChanged = true;
    s.canSaved = s.dataChanged;
    s.after = { ...this.state.after, ...obj };
    this.setState(s);
  };
  doSave = () => {
    try {
      var check = validate_Data(this.state.after);
      //chuyen doi format
      var data = myLib.cloneObject(this.state.after);
      var values = data.ShipName.split("\n"); //string
      var list = [];
      values.map((str) => {
        var ps = str.split(";");
        var x = Number(ps[0]);
        var y = Number(ps[1]);
        list.push([x, y]);
      });
      data.ShipName = list; //thay the array number
      var action = this.props.edittingRecord ? "update" : "insert";
      if (!check.error) {
        this.setState({ validateStatus: check, saving: true, errorLog: "" });
        server
          .post("Data/DoRequest", {
            Function: "Proc_DM_CheckRule_CopyTo",
            ThamSo: data,
          })
          .then((response) => {
            this.setState({
              dataChanged: false,
              canSaved: false,
              saving: false,
              errorMessage: "",
              errorLog: "",
            });
            //thong bao cho parent biet co data duoc saved
            if (this.props.onSaved) {
              this.props.onSaved(action, data);
            }
            alert("Cập nhật thành công!");
          })
          .catch((error) => {
            handleServerError(error);
            this.setState({ saving: false });
          });
      } else {
        this.setState({ validateStatus: check });
        showError("Vui lòng kiểm tra các trường đánh dấu đỏ!");
      }
    } catch (ex) {
      showError(ex);
    }
  };
  doRunRule = () => {
    try {
      this.setState({ checking: true, errorLog: "" });
      server
        .post("Data/DoRequest", {
          Function: "Proc_DM_CheckRule_Test",
          ThamSo: {
            ShipID: this.state.after.ShipID,
            CheckRuleID: this.state.after.CheckRuleID,
          },
        })
        .then((response) => {
          this.setState({
            dataChanged: false,
            canSaved: false,
            checking: false,
            errorMessage: "",
            errorLog: "",
          });

          alert("Đã xong!");
        })
        .catch((error) => {
          handleServerError(error);
          this.setState({ checking: false });
        });
    } catch (ex) {
      this.setState({ checking: false });
      showError(ex);
    }
  };
  render() {
    return (
      <Dialog
        open={this.props.open}
        maxWidth={"md"}
        fullWidth={true}
        onClose={() => { }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{formTitle}</DialogTitle>
        <DialogContent>
          <div
            style={{
              minWidth: 500,
              minHeight: 30,
              padding: 5,
              fontSize: 10,
              wordWrap: "break-word",
            }}
          >
            <Grid container spacing={1} columns={24}>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.ShipName}</FormLabel>
              </Grid>
              <Grid item xs={20}>
                <OutlinedInput
                  id="ShipName"
                  fullWidth
                  readOnly
                  inputProps={{
                    style: { textTransform: "uppercase" },
                    maxLength: 40,
                  }}
                  value={this.state.after.ShipName}
                  error={this.state.validateStatus.CheckRuleID !== undefined}
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.ToShip}</FormLabel>
              </Grid>
              <Grid item xs={20}>
                <MySelectFilter
                  id={"ShipID"}
                  key={"ShipID"}
                  fullWidth
                  autoFocus={false}
                  options={this.props.DanhMuc.DM_Ship}
                  optionLabel="ShipName"
                  optionValue="ShipID"
                  placeholder=""
                  value={{
                    ShipID: this.state.after.ToShipID,
                    ShipName: this.state.after.ToShipName
                  }}
                  onChange={(item) => {
                    this.saveData({
                      ToShipID: item ? item.ShipID : null,
                      ToShipName: item ? item.ShipName : null,
                    });
                  }}
                ></MySelectFilter>
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.NgayHieuLuc}</FormLabel>
              </Grid>
              <Grid item xs={5}>
                <MyDateEditor
                  id="txtNgayhieuluc"

                  value={this.state.after.NgayHieuLuc}
                  onChange={(value) => {
                    this.saveField("NgayHieuLuc", value);
                  }}
                  error={this.state.validateStatus.NgayHieuLuc !== undefined}
                />
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          {
            /*
            <Button
              onClick={() => {
                if (!this.state.checking) {
                  this.doRunRule();
                }
              }}
              variant="contained"
            >
              {this.state.checking ? "Checking..." : buttonLabels.btnRun}
            </Button>*/
          }
          <Button
            onClick={() => {
              this.doSave();
            }}
            variant="contained"
          >
            {buttonLabels.btnSave}
          </Button>

          <Button
            onClick={() => {
              if (this.props.close) {
                this.props.close(false);
              }
            }}
            variant="contained"
          >
            {buttonLabels.btnClose}
          </Button>
        </DialogActions>

      </Dialog>
    );
  }
}
